import React from "react";
import styled from "styled-components";
import CardReview from "./card.review";
import reviewsbg from "../../assets/images/reviewsbg.jpg";

const Reviews = () => {
  const ReviewsList = [
    {
      name: "Danny T.",
      caption: " DJ Bezi Turns Up the Heat ",
      review:
        "In the cozy space of Slug and Lettuce Aldgate, DJ Bezi spun an unforgettable night of beats. Despite the smaller setting, the energy was electric, and Bezi's curated setlist kept the intimate crowd on their feet. The seamless transitions between tracks and Bezi's ability to read the room created a unique connection between the DJ and the audience. The lighting and visuals, though on a smaller scale, added a touch of magic to the night. In summary, DJ Bezi's performance was a testament to the power of music to create an unforgettable experience, even in a smaller setting. If you're looking for an intimate yet electrifying event, don't miss DJ Bezi's next jam.",
    },
    {
      name: "Susan R.",
      caption: " DJ Bezi's Cozy Groove Night",
      review:
        "DJ Bezi transformed Chaser Bar & Lounge into a vibrant dance floor, weaving a seamless tapestry of beats that resonated with the close-knit crowd. With expertly curated tracks and an intimate vibe, Bezi's performance created an unforgettable night, proving that big experiences can come in small packages. If you're seeking an up-close musical connection, DJ Bezi is a must-experience.",
    },
    {
      name: "Nick J.",
      caption: " Unforgettable Night of Beats",
      review:
        "DJ Bezi's night at Cyberdog was a sonic journey that left the crowd craving more. Bezi's seamless blend of genres, curated setlist, and masterful transitions showcased musical prowess. The crowd became a unified force on the dance floor, responding to every beat with infectious energy. The lighting and visual effects were spectacular, creating a sensory feast that elevated the entire experience. In summary, DJ Bezi delivered an unforgettable night of pulsating beats and a sense of camaraderie among music enthusiasts. If you're in search of a DJ who knows how to create an immersive and unforgettable experience, DJ Bezi is the one to watch.",
    },
  ];
  return (
    <MainWrap>
      <Overlay />
      <Title> Soundscapes Unleashed: Reviews Corner</Title>
      <ReviewsWrap>
        {ReviewsList.map((review, idx) => (
          <CardReview
            key={idx}
            name={review.name}
            caption={review.caption}
            rev={review.review}
          />
        ))}
      </ReviewsWrap>
    </MainWrap>
  );
};

export default Reviews;

const MainWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${reviewsbg});
  background-size: cover;
  background-position: center;

  @media (max-width: 767px) {
    width: 100vw;
  }
`;

const Overlay = styled.div`
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

const Title = styled.div`
  font-size: 30px;
  font-family: "Open Sans", sans-serif;
  padding: 50px 0;
  z-index: 2;

  @media (max-width: 767px) {
    padding: 20px 0;
    font-size: 20px;
  }
`;

const ReviewsWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 50px 0;
  z-index: 2;

  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;
